module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./carousel.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/carousel.md
// module id = Pq0V
// module chunks = 0